<mat-toolbar class="header">
  <div class="header-left">
    <div class="logo">
      <img src="../../../assets/images/bwrm-new-logo.png" alt="BWRM">
    </div>
  </div>
  <div class="header-right">
    <div class="zip-processing-spinner">
      <mat-progress-spinner *ngIf="zipProcessing$|async" mode="indeterminate" color="accent" [diameter]="30"
                            [strokeWidth]="2"></mat-progress-spinner>
    </div>
    <div *ngIf="localRefSelectedJob === null || !(serviceCount$ | async); else serviceLoaded"
         class="upload-final-box disabled-uploader-button">
      <svg width="25px" height="19px" viewBox="0 0 25 19" xmlns="http://www.w3.org/2000/svg">
        <g id="Processor" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
          <g id="Processor---Jobs" transform="translate(-1212.000000, -18.000000)">
            <g id="Group-16" transform="translate(1212.000000, 18.000000)">
              <g id="Group-4">
                <path
                  d="M23.125,19 L1.875,19 C0.84125,19 0,18.1475902 0,17.1001267 L0,3.80101327 C0,3.35517632 0.14875,2.71681888 0.345,2.31784548 L1.03625,0.917005533 C1.29375,0.393907073 1.92375,0 2.5,0 L11.25,0 C11.82625,0 12.455,0.393907073 12.71375,0.917005533 L13.405,2.31784548 C13.4525,2.41537231 13.64375,2.53443104 13.75,2.53443104 L23.125,2.53443104 C24.15875,2.53443104 25,3.38684088 25,4.43430438 L25,17.1001267 C25,18.1475902 24.15875,19 23.125,19 Z"
                  id="Path" fill="#1BCD6B"></path>
                <path
                  d="M16.8119509,9.77537415 L12.9545325,6.17549415 C12.7038003,5.94150195 12.2961997,5.94150195 12.0454675,6.17549415 L8.18804915,9.77537415 C7.93731695,10.0093664 7.93731695,10.3897537 8.18804915,10.6237459 C8.43878134,10.8577381 8.84638188,10.8577381 9.09711408,10.6237459 L11.856454,8.04863171 L11.856454,14.40002 C11.856454,14.731209 12.1444746,15 12.4993571,15 C12.8542396,15 13.1422602,14.731209 13.1422602,14.40002 L13.1422602,8.04863171 L15.9016001,10.6237459 C16.0276091,10.741342 16.1921923,10.79894 16.3567755,10.79894 C16.5213587,10.79894 16.6859419,10.740142 16.8119509,10.6237459 C17.062683,10.3897537 17.062683,10.0093664 16.8119509,9.77537415 L16.8119509,9.77537415 Z"
                  id="Shape" fill="#FFFFFF" fill-rule="nonzero"
                  transform="translate(12.500000, 10.500000) rotate(-360.000000) translate(-12.500000, -10.500000) "></path>
              </g>
            </g>
          </g>
        </g>
      </svg>
      <span>Upload Finals</span>
    </div>

    <ng-template #serviceLoaded>
      <div class="upload-final-box" (click)="openUploaderModal()">
        <svg width="25px" height="19px" viewBox="0 0 25 19" xmlns="http://www.w3.org/2000/svg">
          <g id="Processor" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g id="Processor---Jobs" transform="translate(-1212.000000, -18.000000)">
              <g id="Group-16" transform="translate(1212.000000, 18.000000)">
                <g id="Group-4">
                  <path
                    d="M23.125,19 L1.875,19 C0.84125,19 0,18.1475902 0,17.1001267 L0,3.80101327 C0,3.35517632 0.14875,2.71681888 0.345,2.31784548 L1.03625,0.917005533 C1.29375,0.393907073 1.92375,0 2.5,0 L11.25,0 C11.82625,0 12.455,0.393907073 12.71375,0.917005533 L13.405,2.31784548 C13.4525,2.41537231 13.64375,2.53443104 13.75,2.53443104 L23.125,2.53443104 C24.15875,2.53443104 25,3.38684088 25,4.43430438 L25,17.1001267 C25,18.1475902 24.15875,19 23.125,19 Z"
                    id="Path" fill="#1BCD6B"></path>
                  <path
                    d="M16.8119509,9.77537415 L12.9545325,6.17549415 C12.7038003,5.94150195 12.2961997,5.94150195 12.0454675,6.17549415 L8.18804915,9.77537415 C7.93731695,10.0093664 7.93731695,10.3897537 8.18804915,10.6237459 C8.43878134,10.8577381 8.84638188,10.8577381 9.09711408,10.6237459 L11.856454,8.04863171 L11.856454,14.40002 C11.856454,14.731209 12.1444746,15 12.4993571,15 C12.8542396,15 13.1422602,14.731209 13.1422602,14.40002 L13.1422602,8.04863171 L15.9016001,10.6237459 C16.0276091,10.741342 16.1921923,10.79894 16.3567755,10.79894 C16.5213587,10.79894 16.6859419,10.740142 16.8119509,10.6237459 C17.062683,10.3897537 17.062683,10.0093664 16.8119509,9.77537415 L16.8119509,9.77537415 Z"
                    id="Shape" fill="#FFFFFF" fill-rule="nonzero"
                    transform="translate(12.500000, 10.500000) rotate(-360.000000) translate(-12.500000, -10.500000) "></path>
                </g>
              </g>
            </g>
          </g>
        </svg>
        <span>Upload Finals</span>
      </div>
    </ng-template>

    <ng-container *ngIf="(processor | async) as profile">
      <prism-xero-display *ngIf="profile.invoicingPermissions" class="slide-in-btn"></prism-xero-display>
    </ng-container>
    <button class="header-right-btn header-profile-btn" (click)="onLogout()">
      <span>{{ (processorProfileInitials | async) }}</span>
    </button>
  </div>
</mat-toolbar>
